import { type TextareaHTMLAttributes } from 'react';
import { cx, inputClass } from './utils.js';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  flush?: boolean;
};

export function Textarea({ className, flush = false, ...rest }: TextareaProps) {
  return (
    <textarea
      {...rest}
      className={cx(inputClass, flush && 'mt-0', className)}
      data-ui="textarea"
    />
  );
}
